import instance from './instance'

export function getNotification() {
  return instance.get('/settings/notification/')
}

export function putNotification(data) {
  return instance.put('/settings/notification/', data)
}
